import { useContext } from "react";
import { NotificationContext } from "../contexts/NotificationContext";

// Hook customizado para acessar as notificações
export const useNotification = () => {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error("useNotification deve ser usado dentro de NotificationProvider");
  }

  return context;
};
